import PropTypes from 'prop-types';
import globals from '../../../utils/globals';
import styles from './sub-nav-bar.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import Button from 'react-bootstrap/Button';

export const MODES = {
  modal: 'modal',
  link: 'link',
  hide: 'hide'
};

const className = augmentClassName(styles);

const getButtonProps = ({ mode, onClick }) => {
  if (mode === MODES.modal) {
    return {
      onClick
    };
  }

  if (mode === MODES.link) {
    return {
      as: 'a',
      href:
        globals.investButtonUrl,
      target: '_blank',
      rel: 'noopener noreferrer'
    };
  }

  return {};
};

const ButtonInvest = ({ className: classNameProp, mode, onClick }) => {
  if (mode === MODES.hide) {
    return null;
  }

  const classNameString = [
    classNameProp,
    className.string('btn--rounded', 'font-family-agenda', 'font-weight-semibold', 'font-size-14', 'invest-btn-style')
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Button
      variant={'info'}
      size="sm"
      className={classNameString}
      {...getButtonProps({ mode, onClick })}
    >
      Invest
    </Button>
  );
};

ButtonInvest.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.string,
  onClick: PropTypes.func
};

export default ButtonInvest;
